import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';

import { useSpring, animated } from "react-spring";


import boldUnselect from '../assets/icons/chatIcons/boldUnselect.svg';
import italicUnselect from '../assets/icons/chatIcons/italicUnselect.svg';
import underlineUnselect from '../assets/icons/chatIcons/underlineUnselect.svg';
import strikeUnselect from '../assets/icons/chatIcons/strikeUnselect.svg';
import listUnselect from '../assets/icons/chatIcons/listUnselect.svg';
import bulletUnselect from '../assets/icons/chatIcons/bulletUnselect.svg';
import boldSelect from '../assets/icons/chatIcons/boldSelect.svg';
import italicSelect from '../assets/icons/chatIcons/italicSelect.svg';
import underlineSelect from '../assets/icons/chatIcons/underlineSelect.svg';
import strikeSelect from '../assets/icons/chatIcons/strikeSelect.svg';
import listSelect from '../assets/icons/chatIcons/listSelect.svg';
import bulletSelect from '../assets/icons/chatIcons/bulletSelect.svg';
import sendDefault from '../assets/icons/chatIcons/sendDefault.svg';
import { ReactComponent as Trash } from "../assets/icons/Trash.svg";
import { ReactComponent as Cross } from "../assets/icons/CrossM.svg";

import sendButton from '../assets/icons/chatIcons/sendButton.svg';
import Tooltip from './shared/tooltip';
import { ReactComponent as ATTACHMENT } from "../assets/Attachment.svg";


import 'react-quill/dist/quill.snow.css';
import './ChatBox.css';
import ChatMessages from './ChatMessages';
import axios from 'axios';
import { auth, fieldValue, firestore, getFullHttpUrl, storage } from '../firebase.config';
import { v4 as uuidv4 } from 'uuid';
import { EAST1 } from '../utility/enums';
import { AuthContext } from '../Context/AuthContext';
import { FileUploaderButton } from './FileUploaderButton';
import { NotificationContext } from '../Context/NotificationContext';
import GetFileTypeElement from '../Data/Functions/getFileType';

const OrderChatBox = ({type="order", userId, userRole, orderChatId, userData, orderData, disableAutoFocus }) => {
  const [messages, setMessages] = useState([]);
  const [value, setValue] = useState('');
  const [sendIcon, setSendIcon] = useState(sendDefault);
 const [loading, setLoading] = useState(true);
  const [activeList, setActiveList] = useState([])
  const [chatID, setChatID] = useState(orderChatId || null);
  const [isActive, setIsActive] = useState(false);
  const messagesEndRef = useRef(null);
  const [isAttachment, setIsAttachment] = useState(false);

  const { signedIn } = useContext(AuthContext);
  const [files, setFiles] = useState([]);

  const {showNotification} = useContext(NotificationContext);


  const quillRef = useRef(null);
  const skipNextUpdateRef = useRef(false);

  useEffect(() => {

    const unsubscribe = auth.onAuthStateChanged(async (user) => {

      try {
        if (user) {
          
          const chatQuery = await firestore
            .collection('chats')
            .where('itemID', '==', orderData.id)
            .get();

          if (!chatQuery.empty) {
            const chatDoc = chatQuery.docs[0];
            setChatID(chatDoc.id);

            const chatData = chatDoc.data();
            const readMeassages = chatData.messages.map(msg => msg.senderId !== userId ? { ...msg, unRead: false } : msg);
            await chatDoc.ref.update({ messages: readMeassages }); 
           
            firestore
              .collection('chats')
              .doc(chatDoc.id)
              .onSnapshot(
                async (doc) => {
                  if (doc.exists) {
                    const chatData = doc.data();
                    const messages = chatData.messages || [];

                    const senderIds = [...new Set(messages.map((msg) => msg.senderId))];

                    const userDetailsPromises = senderIds.map((senderId) =>
                      firestore.collection('users').doc(senderId).get()
                    );
                    const userDetailsSnapshots = await Promise.all(userDetailsPromises);

                    const userDetails = userDetailsSnapshots.reduce((acc, doc) => {
                      acc[doc.id] = doc.data();
                      return acc;
                    }, {});

                    const messagesWithUserDetails = messages.map((msg) => ({
                      ...msg,
                      senderName: userDetails[msg.senderId]?.name || msg.senderName || "",
                      senderRole: userDetails[msg.senderId]?.role || "",
                      profilePic: userDetails[msg.senderId]?.profilePic || "",
                    }));

                    setMessages(messagesWithUserDetails);
                    scrollToBottom();
                  }
                  setLoading(false);
                },
                (error) => {
                  console.error("Error in snapshot listener:", error);
                  setLoading(false);
                }
              );
          } else {
            console.log("No chat found for the given itemID.");
            setLoading(false);
          }
        } else {
          console.log("No user is signed in.");
        }

      } catch (error) {
        console.log(error)
      }
    });

    return () => unsubscribe();
  }, [orderData]);

  useEffect(() => {
    if (!chatID) return;
  
    const unsubscribe = firestore
      .collection('chats')
      .doc(chatID)
      .onSnapshot(
        async (doc) => {
          if (doc.exists) {
            const chatData = doc.data();
            const readMeassages = chatData.messages.map(msg => msg.senderId !== userId ? { ...msg, unRead: false } : msg);
            await doc.ref.update({ messages: readMeassages }); 

            const messages = chatData.messages || [];
  
            const senderIds = [...new Set(messages.map((msg) => msg.senderId))];
  
            const userDetailsPromises = senderIds.map((senderId) =>
              firestore.collection('users').doc(senderId).get()
            );
            const userDetailsSnapshots = await Promise.all(userDetailsPromises);
  
            const userDetails = userDetailsSnapshots.reduce((acc, doc) => {
              acc[doc.id] = doc.data();
              return acc;
            }, {});
  
            const messagesWithUserDetails = messages.map((msg) => ({
              ...msg,
              senderName: userDetails[msg.senderId]?.name || msg?.senderName || "",
              senderRole: userDetails[msg.senderId]?.role || "",
              profilePic: userDetails[msg.senderId]?.profilePic || "",
            }));
  
            setMessages(messagesWithUserDetails);
            scrollToBottom();
          }
        },
        (error) => {
          console.error("Error in snapshot listener:", error);
        }
      );
  
    return () => unsubscribe();
  }, [chatID]);

  useEffect(() => {
    const quill = quillRef.current?.getEditor();

    if (quill) {
      quill.on('editor-change', (eventName) => {
        if (eventName === 'selection-change') {
          const isModalOpen = document.querySelector('.orderRevisionModalBg');
           if (isModalOpen || !quill.hasFocus()) {
            return;
          }
          const currentFormats = quill.getFormat(); 
          const updatedActiveList = Object.keys(currentFormats); 
         
          if (updatedActiveList.includes('ordered') && updatedActiveList.includes('bullet')) {
            updatedActiveList.splice(updatedActiveList.indexOf('bullet'), 1);
          }

          setActiveList(updatedActiveList);
        }
      });
    }
  }, []);

  useEffect(() => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    if (disableAutoFocus) {
      quill.blur();
      quill.enable(false);
    } else {
      quill.enable(true);
      setTimeout(() => quill.focus(), 300);
    }
  }, [disableAutoFocus]);

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const toggleOption = useCallback((option) => {
    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    // Get current format state directly from Quill
    const range = quill.getSelection() || { index: 0, length: 0 };
    const currentFormats = quill.getFormat(range);

    if (option === 'ordered' || option === 'bullet') {
      const isCurrentlyActive = currentFormats.list === option;
      
      if (!isCurrentlyActive) {
        quill.format('list', option);
      } else {
        quill.format('list', false);
      }
    } else {
      // For bold, italic, underline, strike
      const isCurrentlyActive = currentFormats[option];
      
      if (isCurrentlyActive) {
        quill.format(option, false);
      } else {
        quill.format(option, true);
      }
    }

    setTimeout(() => {
      const newRange = quill.getSelection() || { index: 0, length: 0 };
      const newFormats = quill.getFormat(newRange);
      const updatedActiveList = [];
      
      // Add regular formats
      ['bold', 'italic', 'underline', 'strike'].forEach(format => {
        if (newFormats[format]) {
          updatedActiveList.push(format);
        }
      });

      // Add list format (ordered or bullet)
      if (newFormats.list) {
        updatedActiveList.push(newFormats.list);
      }

      setActiveList(updatedActiveList);
    }, 0);
  }, []);

  const handleSend = async () => {
    if(!signedIn || !userData) return;

    const quill = quillRef.current?.getEditor();
    if (!quill) return;

    // Get the Quill editor's content
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = quill.root.innerHTML; 
    
    // Remove empty list items (`<li>` elements with no content)
    tempDiv.innerHTML = tempDiv.innerHTML.replace(/<li>(?:&nbsp;|\s|<br>)*<\/li>/g, "").trim();
    
    // Remove empty ordered/unordered lists (`<ol></ol>` and `<ul></ul>`)
    tempDiv.innerHTML = tempDiv.innerHTML.replace(/<ol>\s*<\/ol>|<ul>\s*<\/ul>/g, "").trim();
    
    // Remove unnecessary `<p><br></p>` formatting
    const strippedContent = tempDiv.innerHTML.replace(/<p><br><\/p>/g, "").trim();
    
    // If the cleaned content is empty, don't send the message
    if (strippedContent === "" || strippedContent === "<br>" ) return;
    
    const attachedFiles = files.length > 0 ? files.map(f => ({ name: f.name, ref: f.ref, url: f.url, type: 'chat', size: f.file.size, format: f.file.type, timestamp: (new Date()).getTime() })) : [];

    try {
        const messageID = uuidv4();
        let createdChatId = null;
        if (!chatID) {
            if (!orderData.id || !userId || !strippedContent) {
                console.error("Missing required fields for creating chat");
                return;
            }

            const newChatRef = firestore.collection('chats').doc();
            const newChatData = {
                itemID: orderData.id,
                createdAt: fieldValue.serverTimestamp(),
                messages: [
                    {
                        messageID,
                        senderId: userId,
                        message: strippedContent, // Send only the cleaned message
                        timestamp: new Date().getTime(),
                        unRead: true,
                        files: attachedFiles,
                    },
                ],
            };

            await newChatRef.set(newChatData).then(() => firestore.collection(type === "order" ? "orders" : "quotes").doc(orderData.id).update({ generalChatId: newChatRef.id }));
            createdChatId = newChatRef.id;
            setChatID(newChatRef.id);
        } else {
            const chatRef = firestore.collection('chats').doc(chatID);

            await chatRef.update({
                messages: fieldValue.arrayUnion({
                    messageID,
                    senderId: userId,
                    message: strippedContent, // Save only the cleaned message
                    timestamp: new Date().getTime(),
                    unRead: true,
                    files: attachedFiles,
                }),
            });
        }

        quill.setText('');
        setValue('');
        setFiles([]);
        setSendIcon(sendDefault);
        setActiveList([]);
        scrollToBottom();
        
        
        const currentChatId = createdChatId || chatID;
        console.log(
          {
            type:type,
            orderData: orderData,
            userData: userData,
            message: {
              messageID,
              message: strippedContent,
            },
            chatId: currentChatId,
            messageId: messageID,
          }
        );
        axios.post(
          getFullHttpUrl("newChatMessage", EAST1),
          {
            type:type,
            orderData: { ...orderData, generalChatId: currentChatId },
            userData: userData,
            message: {
              messageID,
              message: strippedContent,
            },
            chatId: currentChatId,
            messageId: messageID,
          }
        ).catch((apiError) => {
          console.error("Error posting to API:", apiError);
        });

    } catch (error) {
        console.error('Error sending message:', error);
    }
};


  const handleKeyPress = (e) => {
    if(!signedIn || !userData) return;

    if (e.key === 'Enter' && !(e.shiftKey)) {
        e.preventDefault();
        
        const quill = quillRef.current?.getEditor();
        if (!quill) return;

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = quill.root.innerHTML; // Get the Quill editor content

        // Remove empty list items (`<li>` elements with no content)
        tempDiv.innerHTML = tempDiv.innerHTML.replace(/<li>(?:&nbsp;|\s|<br>)*<\/li>/g, "").trim();

        // Remove empty ordered/unordered lists (`<ol></ol>` and `<ul></ul>`)
        tempDiv.innerHTML = tempDiv.innerHTML.replace(/<ol>\s*<\/ol>|<ul>\s*<\/ul>/g, "").trim();

        // Remove unnecessary `<p><br></p>` formatting
        const strippedContent = tempDiv.innerHTML.replace(/<p><br><\/p>/g, "").trim();

        // If the cleaned content is empty, don't send the message
        if (strippedContent !== "" && strippedContent !== "<br>") {
            handleSend(); // Send the cleaned message

            // Reset the editor after sending the message
            quill.setText('');
            setValue('');
            setSendIcon(sendDefault);
        }
    }
};


  const handleEditorChange = (content) => {
    // Normalize content for emptiness detection but don’t destroy structure
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Remove purely empty formatting nodes
    tempDiv.innerHTML = tempDiv.innerHTML
      .replace(/<(strong|em|u|s|b|i|span)>(\s|&nbsp;|<br>|<\/?[^>]+>)*<\/\1>/gi, '')
      .replace(/<li>(?:&nbsp;|\s|<br>)*<\/li>/g, '')
      .trim();

    const cleanedText = tempDiv.textContent?.replace(/\s|\n|&nbsp;/g, '').trim() || '';
    const isEmpty = cleanedText.length === 0;

    // Keep the editor content as-is so Quill keeps its structure
    setValue(content);
    setIsActive(!isEmpty);
    setSendIcon(isEmpty ? sendDefault : sendButton);
  };



  useEffect(() => {
    const quill = quillRef.current?.getEditor();

    if (quill) {
      const updateFormats = () => {
        const range = quill.getSelection();
        if (!range) return;
        
        const currentFormats = quill.getFormat(range);
        const updatedActiveList = [];
        
        // Add regular formats
        ['bold', 'italic', 'underline', 'strike'].forEach(format => {
          if (currentFormats[format]) {
            updatedActiveList.push(format);
          }
        });

        // Add list format (ordered or bullet)
        if (currentFormats.list) {
          updatedActiveList.push(currentFormats.list);
        }

        setActiveList(updatedActiveList);
      };

      const handleSelectionChange = (range) => {
        if (range) {
          updateFormats();
        }
      };

      const handleTextChange = () => {
        updateFormats()
      };

      const handleKeyDown = (event) => {
        const isMac = /mac/i.test(navigator.userAgentData?.platform || navigator.userAgent);
        const ctrlKey = isMac ? event.metaKey : event.ctrlKey;

        if (ctrlKey && !event.shiftKey) {
          if (event.key === 'b' || event.key === 'B' ||
              event.key === 'i' || event.key === 'I' ||
              event.key === 'u' || event.key === 'U') {
            setTimeout(updateFormats, 10);
          }
        }

        if (ctrlKey && event.shiftKey) {
          if (event.key === 'x' || event.key === 'X') {
            event.preventDefault();
            toggleOption('strike');
            setTimeout(updateFormats, 10);
          }
          else if (event.key === '7' || event.key === '&') {
            event.preventDefault();
            toggleOption('ordered');
            setTimeout(updateFormats, 10);
          }
          else if (event.key === '8' || event.key === '*') {
            event.preventDefault();
            toggleOption('bullet');
            setTimeout(updateFormats, 10);
          }
        }
      };
      
      // Attach event listeners
      quill.on('selection-change', handleSelectionChange);
      quill.on('text-change', handleTextChange);
      quill.root.addEventListener('keydown', handleKeyDown);

      // Cleanup
      return () => {
        quill.off('selection-change', handleSelectionChange);
        quill.off('text-change', handleTextChange);
        quill.root.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [toggleOption]);

  const handleFiles = async (e) => {
        const mFiles = e.target.files;
    
        const oID = orderChatId;
    
        for (let i = 0; i < mFiles.length; i++) {
          const fileID = uuidv4();
          setFiles(f => f.concat([{ id: fileID, name: mFiles[i].name, file: mFiles[i], progress: 0, status: 'uploading', error: null }]));
        }
    
        const storageRef = storage.ref();
    
        for (let i = 0; i < mFiles.length; i++) {
          const subFolder = uuidv4();
          const fileRef = storageRef.child(oID + '/' + subFolder + '/' + mFiles[i].name);
    
          const downloadToken = uuidv4();
    
          const fileName = mFiles[i].name.replace('#', '%23').replace('+', "%2b");
    
          const url = `${process.env.REACT_APP_STORAGE_URL}/o/${oID}%2F${subFolder}%2F${fileName}?alt=media&token=${downloadToken}`;
    
          var metadata = {
            firebaseStorageDownloadTokens: downloadToken,
            customMetadata: {
              'orderID': oID
            }
          }
    
          const uploadTask = fileRef.put(mFiles[i], metadata);
    
          setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, task: uploadTask } : file));
    
          uploadTask.on('state_changed', (snapshot) => {
            const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, progress: progress.toFixed(2) } : file));
          }, (error) => {
            setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'failed', error: error?.message } : file));
            setFiles(f => f.filter(file => file.name !== mFiles[i].name && file.ref !== mFiles[i].ref));
            showNotification("Error uploading.", "There was an error uploading the file " + mFiles[i].name + ". Please, try again.", "error");
          }, () => {
            setFiles(f => f.map(file => file.name === mFiles[i].name && file.ref === mFiles[i].ref ? { ...file, status: 'complete', ref: oID + '/' + subFolder + '/' + mFiles[i].name, url: url, timestamp: new Date().getTime(), error: null } : file));
          });
        }
    
      }

  const handleDeleteFile = async(file) => {
    const checkFile = (file1, file2) => {
      if(file1.id && file2.id){
        return file1.id === file2.id;
      }
      if(file1.ref && file2.ref){
        return file1.ref === file2.ref;
      }
    }
    const storageRef = storage.ref();

    if (file.ref && (file.status === "complete" || file.timestamp)) {
      const fileRef = storageRef.child(file.ref);
      setFiles((f) =>
        f.map((mFile) =>
          mFile.name === file.name && checkFile(mFile, file)
            ? { ...mFile, status: "deleting" }
            : mFile
        )
      );

      await fileRef
        .delete()
        .then(function () {
          setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
          showNotification("Success", "File deleted successfully.", "success");
        })
        .catch(function (error) {
          showNotification(
            "Error deleting the file.",
            "There was an error deleting the file " +
              file.name +
              ". Please, try again.",
            "error"
          );
        });
    } else if (file.status === "failed") {
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    } else {
      file.task.cancel();
      setFiles((f) => f.filter((mFile) => !checkFile(mFile, file)));
    }
  };

  const CustomToolbar = () => (
    <div className="custom-toolbar ql-toolbar ql-snow">
      <div className='relative'>
        <button className={`toolbar-button ${activeList.includes('bold') ? 'active' : ''}`} onClick={() => toggleOption('bold')}>
          <img src={activeList.includes('bold') ? boldSelect : boldUnselect} alt="Bold" />
        </button>
        <Tooltip text='Bold' letter='B' />
      </div>
      <div className='relative'>
        <button className={`toolbar-button ${activeList.includes('italic') ? 'active' : ''}`} onClick={() => toggleOption('italic')}>
          <img src={activeList.includes('italic') ? italicSelect : italicUnselect} alt="Italic" />
        </button>
        <Tooltip text='Italic' letter='I' />
      </div>
      <div className='relative'>
        <button className={`toolbar-button ${activeList.includes('underline') ? 'active' : ''}`} onClick={() => toggleOption('underline')}>
          <img src={activeList.includes('underline') ? underlineSelect : underlineUnselect} alt="Underline" />
        </button>
        <Tooltip text='Underline' letter='U' />
      </div>
      <div className='relative'>
        <button className={`toolbar-button ${activeList.includes('strike') ? 'active' : ''}`} onClick={() => toggleOption('strike')}>
          <img src={activeList.includes('strike') ? strikeSelect : strikeUnselect} alt="Strike" />
        </button>
        <Tooltip text="Strikethrough" letter="Shift + X" width='120'/>
      </div>
      <div className='relative'>
        <button className={`toolbar-button ${activeList.includes('ordered') ? 'active' : ''}`} onClick={() => toggleOption('ordered')}>
          <img src={activeList.includes('ordered') ? listSelect : listUnselect} alt="Ordered List" />
        </button>
        <Tooltip text="Numbered List" letter="Shift + 7" width='120'/>
      </div>
      <div className='relative'>
        <button className={`toolbar-button ${activeList.includes('bullet') ? 'active' : ''}`} onClick={() => toggleOption('bullet')}>
          <img src={activeList.includes('bullet') ? bulletSelect : bulletUnselect} alt="Bullet List" />
        </button>
        <Tooltip text="Bulleted List" letter="Shift + 8" width='120'/>
      </div>
       <div className="relative">
        <ATTACHMENT 
          className="revisionSingleOrderRichTextButton" 
          onMouseDown={(e) => {
            e.preventDefault();
            setIsAttachment(true);
          }} 
          style={{
            color: isAttachment ? '#12ABBF' : '#2D3643',
            border: isAttachment ? '1px solid #12ABBF' : '1px solid transparent',
          }} 
        />
        <Tooltip text="Upload file(s)" width='120' icon={false}/>
      </div>
    </div>
  );

  const modules = {
    toolbar: {
      container: '.custom-toolbar',
    },
  };

  const formats = ['bold', 'italic', 'underline', 'strike', 'list', 'bullet'];


  return (
    <div className="chatDisplay">
      {loading ? (
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            ) : !messages.length ? (
              <div className="noMessageContainer">
                <h3>You Don't Have Messages Yet</h3>
                {signedIn && userData ? <p>Send your first</p> : <p>Please sign in to send messages</p>}
              </div>
            ) : (
              <ChatMessages messages={messages} userRole={userRole} userData={userData}/>
            )}

              {files.length > 0 && (
                      <div className="fileListContainer my-1 w-full flex flex-col gap-3 max-h-[110px] min-h-[50px] overflow-auto">
                      {[...files]
                        .sort((a, b) => b.timestamp - a.timestamp)
                        .map((file, index, sortedFiles) => (
                          <div 
                            key={file.id}
                            className="fileUploaderLineOuter"
                            style={{
                              gap:'4px',
                              height: file?.error ? '45px' : 'auto',
                              ...(sortedFiles.length >= 2 && index > 0
                                  ? { borderTop: "1px solid var(--Grey-Colors-Grey-10, #E6E7E9)", paddingTop: "12px" }
                                  : {})
                            }}
                          >
                            <div className="fileUploaderLine">
                              <div className="fileUploaderLineInfo" style={{gap:'12px'}}>
                                <GetFileTypeElement file={file}/>
                                <p
                                  className="fileUploaderLineName"
                                  style={{ maxWidth: "100%" }}
                                >
                                  {file.name}
                                </p>
                              </div>

                              <div className="flex md:gap-4 md:justify-end justify-around items-center">
                                {/* {file.status !== "uploading" &&
                                  file.timestamp && (
                                    <p className="fileUploaderLineSize">
                                      {formatDateFile(file.timestamp)}
                                    </p>
                                )} */}

                                {file.status === "uploading" ? (
                                  <>
                                    <div className="fileUploaderLineProgressContainer">
                                      <animated.div
                                        style={{
                                          width: `${file.progress}%`,
                                          borderRadius: '60px',
                                          borderBottomWidth: '7px'
                                        }}
                                        className="fileUploaderLineProgress"
                                      />
                                    </div>
                                    <span className="fileProgress">
                                      {Math.round(file.progress)}%
                                    </span>
                                  </>
                                ) : null}

                                {file.status === "uploading" && (
                                  <Cross
                                    className="fileUploaderLineIcon"
                                    onClick={() => handleDeleteFile(file)}
                                  />
                                )}
                                {file.status !== "uploading" && (
                                  <Trash
                                    className="fileUploaderLineIcon"
                                    onClick={() => handleDeleteFile(file)}
                                  />
                                )}

                                {/* {file.status === "complete" && (
                                  <DOWNLOAD
                                    className="hardCopyAddressIcon"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleDownloadFile(file, showNotification)}
                                  />
                                )} */}
                              </div>
                            </div>
                            {file.file.error && (
                              <>
                                <div 
                                style={{
                                  background: 'var(--Other-Red, #D70015)',
                                  width:'100%', 
                                  height:'1px',
                                  marginLeft: '70px'
                                }}
                                />
                                <p className="fileErrorMessage">
                                  {file.file.error || "This is an error"}
                                </p>
                              </>
                            )}
                          </div>
                        ))}
                      </div>
                    )}  

            {isAttachment && (
                  <div
                    className="absolute inset-0 z-50 flex items-center justify-center bg-transparent"
                    onClick={(e) => { setIsAttachment(false);}}
                  >
                    <div 
                      className="uploadFileModal"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div 
                        className="singleQuoteMainPrimaryFilesTitle" 
                        style={{fontSize:'16px', padding:'0', color: '#030F23'}}
                      >
                        Upload Files
                      </div>
                      {
                        <div style={{margin: '0'}} className="quoteDetailsFileUploaderContainer">
                          <FileUploaderButton
                            text="Add Files"
                            files={[files]}
                            handleFiles={(e) => {
                              handleFiles(e);
                              setIsAttachment(false);
                            }}
                            handleDeleteFile={handleDeleteFile}
                            display={false}
                            multiple={true}
                            hideUploadBox={false}
                          />
                        </div>
                      }
                    </div>
                  </div>
                )}  


      <div className={`chatDisplayContainer relative ${isActive ? 'active-chat-border' : ''}`}>
        {!signedIn || !userData ? <div className="absolute top-0 left-0 w-full h-full z-10 text-[0.85rem] flex justify-center items-center bg-[#f0f0f0]/70">
          Please sign in to send messages
        </div> : orderData.sample ? <div className="absolute top-0 left-0 w-full h-full z-10 text-[0.85rem] flex justify-center items-center bg-[#f0f0f0]/70">
          This is a sample chat. You can't send messages.
        </div> : ""}
        <CustomToolbar />
        <div className="editor-container">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={value}
            onChange={handleEditorChange}
            modules={modules}
            formats={formats}
            placeholder="Message"
            onKeyDown={handleKeyPress}
          />
          <button className="send-button" onClick={handleSend}>
            <img src={sendIcon} alt="Send" className="send-icon" />
          </button>
        </div>
      </div>
    </div>
  );

};

export default OrderChatBox;
